import React from "react";
import { useTranslation } from "react-i18next";
// ui
import { Box, Title } from "@mantine/core";
import { useColors } from "@utils/useColors";
// styles
import cx from "./content_highlight_card.module.css";
// components
import { AnimatedHeightWrapper } from "@components/AnimatedHeightWrapper";

export const ContentHighlightCard = React.memo<React.PropsWithChildren>(
  (props) => {
    const { t } = useTranslation();
    const colors = useColors();
    return (
      <Box className={cx["set-password-card"]} bg={colors.beige}>
        <Box className={cx["set-passord-content"]}>
          <Title className={cx["set-password-card-header"]}>
            {t("startPage.cardHeader")}
          </Title>

          <AnimatedHeightWrapper>{props.children}</AnimatedHeightWrapper>
        </Box>
      </Box>
    );
  },
);

ContentHighlightCard.displayName = "ContentHighlightCard";
